const windowScrollBy = (top = 0, behavior = 'smooth') => window.scrollBy({ top, behavior });

const windowScrollTo = (top = 0, behavior = 'smooth') => window.scrollTo({ top, behavior });

export {
    windowScrollBy,
    windowScrollTo,
};
